var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsmActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.9913L8.41675 14.9078L9.6 13.7245L12.5 16.6245L18.3668 10.7578L19.55 11.9413L12.5 18.9913ZM18 8.78276H16.3333V3.66626H14.6668V6.16626H3.33325V3.66626H1.66675V18.3328H7.85V19.9995H1.66675C1.19442 19.9995 0.798583 19.8398 0.47925 19.5203C0.15975 19.2009 0 18.8051 0 18.3328V3.66626C0 3.19393 0.15975 2.79809 0.47925 2.47876C0.798583 2.15926 1.19442 1.99951 1.66675 1.99951H6.425C6.56383 1.41618 6.87492 0.937012 7.35825 0.562012C7.84158 0.187012 8.38883 -0.000488281 9 -0.000488281C9.62217 -0.000488281 10.1736 0.187012 10.6543 0.562012C11.1347 0.937012 11.4444 1.41618 11.5833 1.99951H16.3333C16.8056 1.99951 17.2014 2.15926 17.5208 2.47876C17.8403 2.79809 18 3.19393 18 3.66626V8.78276ZM9 3.66626C9.28333 3.66626 9.52083 3.57043 9.7125 3.37876C9.90417 3.1871 10 2.94959 10 2.66626C10 2.38293 9.90417 2.14543 9.7125 1.95376C9.52083 1.76209 9.28333 1.66626 9 1.66626C8.71667 1.66626 8.47917 1.76209 8.2875 1.95376C8.09583 2.14543 8 2.38293 8 2.66626C8 2.94959 8.09583 3.1871 8.2875 3.37876C8.47917 3.57043 8.71667 3.66626 9 3.66626Z",
    fill: "#176939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsmActiveIcon);
export default __webpack_public_path__ + "static/media/csm_active_icon.1f6359ffb1f9845545dd7876f112ba78.svg";
export { ForwardRef as ReactComponent };